import React from 'react';

import cx from 'classnames';
import { Column } from 'react-table';

import { WorkspaceItem } from '~teacher/hook/workspaces/useWorkspaceItems';

interface Props {
  children: React.ReactNode;
  column: Column<WorkspaceItem>;
  header?: boolean;
  onClick?: () => void;
}

export function WorkspaceItemTableCell({
  children,
  column,
  header,
  onClick,
}: Props) {
  const cellCx = cx(
    'flex items-center antialiased',
    column.id === 'name' && 'flex-grow flex-1 truncate',
    column.id === 'modified' ? 'min-w-40' : 'min-w-12 ',
    'text-left',
    column.id === 'selection' && 'flex items-center justify-center min-w-16',
    column.id === 'actions' && 'flex items-center justify-center min-w-16',
    !header && 'text-base text-blue-900 ',
    header &&
      'text-xs font-700 leading-8 text-cyan-700 tracking-wider uppercase select-none flex flex-row',
    column.id === 'modified' && 'hidden sm:flex'
  );
  return (
    <div
      className={cellCx}
      onClick={
        column.id !== 'selection' && column.id !== 'actions'
          ? onClick
          : undefined
      }
    >
      {header || column.id !== 'name' ? (
        children
      ) : (
        <span className={'block truncate'}>{children}</span>
      )}
    </div>
  );
}
